module.exports = __webpack_public_path__ + "static/media/close-circle-red.acb3d3b5.svg";